export default {
    morado_100: "#34094E",

    azul_100: "#2B81D6",

    rojo_100: "#d00000",

    verde_100: "#38b000"
}